export const MESSAGES_CAV = {
  REFRESH: {
    ERROR: {
      variant: "destructive" as const,
      description: "Erro ao atualizar dados. Tente novamente.",
    },
  },
  EXPORT: {
    SUCCESS: (count: number) => ({
      description: `Exportado ${count.toLocaleString("pt-BR")} transaco${count !== 1 ? "es" : ""} com sucesso.`,
    }),
    ERROR: {
      variant: "destructive" as const,
      description: "Erro ao exportar transacoes. Tente novamente.",
    },
    EMPTY_SELECTION: {
      description: "Selecione ao menos uma transacao para exportar",
    },
  },
  LIST: {
    ERROR: {
      variant: "destructive" as const,
      description: "Erro ao buscar transacoes. Tente novamente.",
    },
  },
};
